var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"danger ml-2"},[_vm._v(_vm._s(_vm.requiredMessage))])
}
var staticRenderFns = []

export { render, staticRenderFns }